import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Divider = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_divider_lazy" */
    "./divider.js"
  )
);
const DividerRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(Divider, { node, nodeIndex, NodeViewContainer, ...props });
};
const DividerLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(DividerRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.DIVIDER]: DividerLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
